var cursor = document.querySelector('.cursor')
var cursorinner = document.querySelector('.cursor2')
var a = document.querySelectorAll('a')
document.addEventListener('mousemove', function (e) {
    var x = e.clientX
    var y = e.clientY
    cursor.style.transform = `translate3d(calc(${x}px - 50%), calc(${y}px - 50%), 0)`
})

document.addEventListener('mousemove', function (e) {
    var x = e.clientX
    var y = e.clientY
    cursorinner.style.left = x + 'px'
    cursorinner.style.top = y + 'px'
})

document.addEventListener('mousedown', () => {
    cursor.classList.remove('mouse-up')
    if (cursor.classList.contains('mouse-down') == false) {
        cursor.classList.add('mouse-down')
    }
})

document.addEventListener('mouseup', () => {
    cursor.classList.remove('mouse-down')
    if (cursor.classList.contains('mouse-up') == false) {
        cursor.classList.add('mouse-up')
    }
})
addEventListener('click', () => {})
{
    if (cursor.classList.contains('mouse-click') == false) {
        cursor.classList.toggle('mouse-click')
    }
}
a.forEach(item => {
    item.addEventListener('mouseover', () => {
        cursorinner.classList.add('inner-circle-hover')
    })
    item.addEventListener('mouseleave', () => {
        cursorinner.classList.remove('inner-circle-hover')
    })
})
//cursor animations

const cursorModifiers = document.querySelectorAll('a')

cursorModifiers.forEach(cursorModifier => {
    cursorModifier.addEventListener('mouseenter', function () {
        cursor.classList.add('enter')
    })

    cursorModifier.addEventListener('mouseleave', function () {
        cursor.classList.remove('enter')
        cursor.style.left = 0 + 'px'
    })
})
